import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { X, ArrowRight, ArrowLeft } from 'lucide-react';

export default function OnboardingTour() {
  const [showTour, setShowTour] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: 'Benvenuto su ZonePass! 👋',
      description: 'Ti guideremo attraverso le funzionalità principali. Ci vorranno solo 2 minuti!',
      position: 'center'
    },
    {
      title: '📊 Dashboard',
      description: 'Panoramica dei tuoi eventi attivi, statistiche di vendita e presenze in tempo reale.',
      position: 'center'
    },
    {
      title: '📅 Eventi',
      description: 'Crea e gestisci tutti i tuoi eventi. Configura biglietti, zone di accesso, prezzi e molto altro.',
      position: 'center'
    },
    {
      title: '📱 Scanner QR',
      description: 'Usa la fotocamera per scansionare i QR code dei biglietti. Traccia entrate e uscite in tempo reale.',
      position: 'center'
    },
    {
      title: '⚙️ Impostazioni',
      description: 'Configura il tuo metodo di pagamento (IBAN, PayPal, Stripe) per ricevere i pagamenti.',
      position: 'center'
    },
    {
      title: '🚀 Sei pronto!',
      description: 'Ora puoi creare il tuo primo evento e iniziare a vendere biglietti. Hai bisogno di aiuto? Usa il chat widget viola in basso a destra!',
      position: 'center'
    }
  ];

  useEffect(() => {
    const hasSeenTour = localStorage.getItem('hasSeenOnboardingTour');
    // Onboarding temporaneamente disabilitato per testing
    // if (!hasSeenTour) {
    //   setTimeout(() => {
    //     setShowTour(true);
    //   }, 1500);
    // }
  }, []);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleClose = () => {
    setShowTour(false);
    localStorage.setItem('hasSeenOnboardingTour', 'true');
  };

  const handleSkip = () => {
    handleClose();
  };

  if (!showTour) return null;

  const currentStepData = steps[currentStep];
  const isLastStep = currentStep === steps.length - 1;
  const isFirstStep = currentStep === 0;

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4 animate-in fade-in duration-200">
      <Card className="w-full max-w-2xl shadow-2xl">
        <CardContent className="p-8 relative">
          <button
            onClick={handleSkip}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Chiudi tour"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-purple-600">
                Passo {currentStep + 1} di {steps.length}
              </span>
              <div className="flex gap-1">
                {steps.map((_, index) => (
                  <div
                    key={index}
                    className={`h-1.5 w-8 rounded-full transition-colors ${
                      index <= currentStep ? 'bg-purple-600' : 'bg-gray-200'
                    }`}
                  />
                ))}
              </div>
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              {currentStepData.title}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              {currentStepData.description}
            </p>
          </div>

          <div className="flex items-center justify-between gap-4">
            <Button
              variant="ghost"
              onClick={handleSkip}
              className="text-gray-600"
            >
              Salta
            </Button>
            
            <div className="flex gap-3">
              {!isFirstStep && (
                <Button
                  variant="outline"
                  onClick={handlePrev}
                  className="gap-2"
                >
                  <ArrowLeft className="w-4 h-4" />
                  Indietro
                </Button>
              )}
              
              <Button
                onClick={handleNext}
                className="bg-purple-600 hover:bg-purple-700 gap-2 px-6"
              >
                {isLastStep ? 'Inizia' : 'Avanti'}
                {!isLastStep && <ArrowRight className="w-4 h-4" />}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
